import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_customer_review_reply_history_RowClass } from "../../dbschema";

export class GenericDocCustomerReviewReplyHistoryModel extends BaseContainerModel {

    bl_fi_generic_doc_customer_review_reply_history: bl_fi_generic_doc_customer_review_reply_history_RowClass = new bl_fi_generic_doc_customer_review_reply_history_RowClass();
}